import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import FormSkeleton from "@/components/loadings/skeleton/FormSkeleton";
import type { ChildRouteContext } from "@/root";

import NewRequest from "@/modules/application/user/components/NewRequest";
import { fetchApplicationVersionQueryOptions } from "@/modules/application/user/services";

export const Route = createFileRoute(
  "/_panel/_application/application/applications/$id/request",
)({
  component: Component,
  pendingComponent: FormSkeleton,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("New Request", { ns: "application.user" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchApplicationVersionQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
});

function Component() {
  const { id } = Route.useParams();

  return <NewRequest id={id} />;
}
